import React from "react";
import "./UIUXDesign.css";

const UIUXDesign = () => {
  return (
    <div>
      <p>this is UIUX Design</p>
      <p>this is UIUX Design</p>
      <p>this is UIUX Design</p>
      <p>this is UIUX Design</p>
      <p>this is UIUX Design</p>
      <p>this is UIUX Design</p>
      <p>this is UIUX Design</p>
      <p>this is UIUX Design</p>
      <p>this is UIUX Design</p>
      <p>this is UIUX Design</p>
      <p>this is UIUX Design</p>
      <p>this is UIUX Design</p>
      <p>this is UIUX Design</p>
      <p>this is UIUX Design</p>
      <p>this is UIUX Design</p>
      <p>this is UIUX Design</p>
      <p>this is UIUX Design</p>
      <p>this is UIUX Design</p>
      <p>this is UIUX Design</p>
    </div>
  );
};

export default UIUXDesign;
